// extracted by mini-css-extract-plugin
export var pillWrapper = "_yl-0";
export var showOverflow = "_yl-1";